import { InfoBlock, useTranslator } from "@sia/style-guide";
import { useContext } from "react";
import { WizarContext } from "contexts/WizardContext";

const Summary = () => {
  const translate = useTranslator();
  const { state } = useContext(WizarContext);
  let singleMember = state.corporate.singleMember;
  let corporateInfo = state.corporate.corporateInfo;
  let mainAddress = state.corporate.mainAddress;
  let ahv = state.corporate.ahv;
  let communicationInfo = state.corporate.communicationInfo;

  let newsletters = {
    newsLetterGerman: translate("wizard.form.single.communication.newsletter.german.label"),
    newsLetterFrench: translate("wizard.form.single.communication.newsletter.french.label"),
    siaInformNewsletterDe: translate("wizard.form.single.communication.inform-newsletter.german.label"),
    siaInformNewsletterFr: translate("wizard.form.single.communication.inform-newsletter.french.label"),
    siaInformNewsletterIt: translate("wizard.form.single.communication.inform-newsletter.italian.label"),
  };

  let selectedNewsletter = Object.keys(newsletters).filter((key) => communicationInfo[key]);

  return (
    <div className="summary-info-page">
      <p className="sia-text-03 sia-margin-03-top sia-margin-02-bottom">{translate("wizard.form.corporate.summary.singleChoices.title")}</p>
      <InfoBlock>
        <span className="label">{translate("wizard.form.corporate.singleChoice.sia-id.label")}</span>
        <p>{singleMember.siaId}</p>
        <span className="label">{translate("wizard.form.corporate.singleChoice.firstname.label")}</span>
        <p>{singleMember.firstname}</p>
        <span className="label">{translate("wizard.form.corporate.singleChoice.lastname.label")}</span>
        <p>{singleMember.lastname}</p>
      </InfoBlock>

      <p className="sia-text-03 sia-margin-03-top sia-margin-02-bottom">{translate("wizard.form.corporate.summary.info.title")}</p>
      <InfoBlock>
        <span className="label">{translate("wizard.form.corporate.info.name")}</span>
        <p>{corporateInfo.name}</p>
        {corporateInfo.extraName && (
          <>
            <span className="label">{translate("wizard.form.corporate.info.extra-name")}</span>
            <p>{corporateInfo.extraName}</p>
          </>
        )}
        <span className="label">{translate("wizard.form.corporate.info.founding-date")}</span>
        <p>{corporateInfo.foundingDate}</p>
        <span className="label">{translate("wizard.form.corporate.info.language")}</span>
        <p>{corporateInfo.language.label}</p>
        <span className="label">{translate("wizard.form.corporate.info.uid")}</span>
        <p>{corporateInfo.uid}</p>
        {corporateInfo.websiate && (
          <>
            <span className="label">{translate("wizard.form.corporate.info.website")}</span>
            <p>{corporateInfo.websiate}</p>
          </>
        )}
        <span className="label">{translate("wizard.form.corporate.info.branch")}</span>
        <p>{corporateInfo.branch.label}</p>
        <span className="label">{translate("wizard.form.corporate.info.specialities")}</span>
        <p>{corporateInfo.specialites.label}</p>
      </InfoBlock>

      <p className="sia-text-03 sia-margin-03-top sia-margin-02-bottom">{translate("wizard.form.corporate.summary.mainAddress.title")}</p>
      <InfoBlock>
        <span className="label">{translate("wizard.form.corporate.mainAddress.street.label")}</span>
        <p>{mainAddress.street}</p>
        {mainAddress.streetTwo && (
          <>
            <span className="label">{translate("wizard.form.corporate.mainAddress.street2.label")}</span>
            <p>{mainAddress.streetTwo}</p>
          </>
        )}
        <span className="label">{translate("wizard.form.single.personal-info.zip.label")}</span>
        <p>{mainAddress.zip}</p>
        <span className="label">{translate("wizard.form.single.personal-info.city.label")}</span>
        <p>{mainAddress.city}</p>
        <span className="label">{translate("wizard.form.single.personal-info.country.label")}</span>
        <p>{mainAddress.country.label}</p>
        <span className="label">{translate("wizard.form.single.personal-info.canton.label")}</span>
        <p>{mainAddress.canton.label}</p>
        {mainAddress.phone && (
          <>
            <span className="label">{translate("wizard.form.corporate.mainAddress.phone.label")}</span>
            <p>{mainAddress.phone}</p>
          </>
        )}
        {mainAddress.email && (
          <>
            <span className="label">{translate("wizard.form.corporate.mainAddress.email.label")}</span>
            <p>{mainAddress.email}</p>
          </>
        )}
      </InfoBlock>
      <p className="sia-text-03 sia-margin-03-top sia-margin-02-bottom">{translate("wizard.form.corporate.ahv.label")}</p>
      <InfoBlock>
        <span className="label">{translate("wizard.form.corporate.ahv.year.label")}</span>
        <p>{ahv.year}</p>
        <span className="label">{translate("wizard.form.corporate.ahv.sum.label")}</span>
        <p>{ahv.sum}</p>
        <span className="label">{translate("wizard.form.corporate.ahv.upload.label")}</span>
        <p>{ahv.ahvFile[0].file.name}</p>
        <span className="label">{translate("wizard.form.corporate.ahv.numberOfEmployees.label")}</span>
        <p>{ahv.numberOfEmployees}</p>
      </InfoBlock>

      {(communicationInfo.selectedMagazine || selectedNewsletter.length > 0) && (
        <p className="sia-text-03 sia-margin-03-top sia-margin-02-bottom">{translate("wizard.form.single.communication.magazins.label")}</p>
      )}
      {communicationInfo.selectedMagazine && (
        <InfoBlock>
          <span className="label">{translate("wizard.form.single.summary.selected.label")}</span>
          <p>{communicationInfo.selectedMagazine}</p>
          <span className="label">{translate("wizard.form.single.summary.format.label")}</span>
          {communicationInfo.magazineFormatEpaper && <p>{translate("subscriptionBox.form.e-paper")}</p>}
          {communicationInfo.magazineFormatPrinted && <p>{translate("subscriptionBox.form.printed")}</p>}
        </InfoBlock>
      )}
      {selectedNewsletter.length > 0 && (
        <InfoBlock>
          <span className="label">{translate("wizard.form.single.summary.selected.label")}</span>
          {selectedNewsletter.map((key) => (
            <p>{translate(newsletters[key])}</p>
          ))}
        </InfoBlock>
      )}
    </div>
  );
};

export default Summary;
